module.exports = __webpack_public_path__ + "static/media/eight-ball.bc1b7d86.png";